/**
 * @ Author: Zhang Yujun
 * @ Create Time: 2025-01-21 17:12:05
 * @ Modified by: Zhang Yujun
 * @ Modified time: 2025-02-15 01:14:21
 * @ Description:
 */

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import CONFIG from './config'
import axios from './axios'
import 'reset.css'
import 'animate.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
console.log('Environment:', process.env.NODE_ENV)
console.log('Api:', process.env.VUE_APP_API)

Vue.config.productionTip = false

Vue.prototype.$config = CONFIG
Vue.prototype.$axios = axios

function isMobile () {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    userAgent
  )
}

if (isMobile()) {
  const hashPath = window.location.hash.replace('#', '') // /home/secondColumn
  window.location.href = `/mb#${hashPath}`
}
// 设置请求头Token
axios.post('isg/token').then(res => {
  axios.defaults.headers.common.Authorization = res.data

  // 暴露到全局，以备之后调试使用
  window._vm = new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
